import {
    getApiErrorDetail,
    isTransparentRateLimitError,
} from '@apps/web/lib/known_api_errors';

export type RequestStatus = 'idle' | 'pending' | 'success' | 'error';

export function requestErrorMessage(
    error: unknown,
    fallback: string,
): string | null {
    if (isTransparentRateLimitError(error)) {
        return null;
    }
    return (
        getApiErrorDetail(error) ??
        (error instanceof Error && error.message ? error.message : fallback)
    );
}
